<template>
  <div class="music-page">
    <div class="row music-page-top">
      <div class="col-12">
        <h1
          style="
            font-family: 'Anton', sans-serif;
            color: white;
            font-size: 48px;
            margin-bottom: 40px;
          "
        >
          MUSIC
        </h1>
        <div v-if="loading" class="loading">
          <p style="color: #888888">Loading tracks...</p>
        </div>
        <div v-else-if="error" class="error">
          <p style="color: #888888">{{ error }}</p>
        </div>
        <div v-else-if="tracks.length === 0" class="no-tracks">
          <p style="color: #888888">No tracks found. Check the console for setup instructions.</p>
        </div>
        <div v-else class="tracks-container">
          <div
            v-for="track in tracks"
            :key="track.id"
            class="track-item"
          >
            <div class="track-embed" v-html="track.embedHtml"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MusicPage",
  data() {
    return {
      tracks: [],
      loading: true,
      error: null,
      // Add your individual SoundCloud track URLs here
      // You can find these by going to your SoundCloud profile,
      // clicking on a track, and copying the URL from the address bar
      trackUrls: [
        'https://soundcloud.com/joshcurtis/chateau-lobby-in-c-for-yacht-captains',
        'https://soundcloud.com/joshcurtis/take-that-universe',
        'https://soundcloud.com/joshcurtis/all-those-voices-yelling',
        'https://soundcloud.com/joshcurtis/mixdown3',
        'https://soundcloud.com/joshcurtis/all-of-you-are-amazing-and-beautiful',
        'https://soundcloud.com/joshcurtis/jupiter',
        'https://soundcloud.com/joshcurtis/breathe'
      ],
    };
  },
  mounted() {
    this.loadTracks();
  },
  methods: {
    async loadTracks() {
      try {
        if (this.trackUrls.length === 0) {
          this.error = "No tracks configured. Please add track URLs in Music.vue";
          this.loading = false;
          return;
        }
        
        await this.embedTracks(this.trackUrls);
      } catch (err) {
        this.error = "Failed to load tracks. Please try again later.";
        this.loading = false;
        console.error("Error loading tracks:", err);
      }
    },
    async embedTracks(trackUrls) {
      const tracks = [];
      
      for (const url of trackUrls) {
        try {
          // Construct the iframe embed URL directly for waveform-only player
          // Use visual=false to get classic waveform player without artwork
          const embedUrl = new URL('https://w.soundcloud.com/player/');
          embedUrl.searchParams.set('url', url);
          embedUrl.searchParams.set('visual', 'false'); // Classic waveform, no artwork
          embedUrl.searchParams.set('show_artwork', 'false');
          embedUrl.searchParams.set('color', '888888'); // Match site color
          embedUrl.searchParams.set('auto_play', 'false');
          embedUrl.searchParams.set('hide_related', 'true');
          embedUrl.searchParams.set('show_comments', 'false');
          embedUrl.searchParams.set('show_user', 'false');
          embedUrl.searchParams.set('sharing', 'false');
          embedUrl.searchParams.set('download', 'false');
          
          // Create iframe HTML directly
          const embedHtml = `<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="${embedUrl.toString()}"></iframe>`;
          
          tracks.push({
            id: url,
            embedHtml: embedHtml,
            title: url.split('/').pop().replace(/-/g, ' '), // Extract title from URL
          });
        } catch (err) {
          console.error(`Failed to load track: ${url}`, err);
        }
      }
      
      if (tracks.length === 0) {
        this.error = "No tracks could be loaded. Please check your track URLs.";
      } else {
        this.tracks = tracks;
      }
      
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.music-page {
  min-height: 100vh;
}

.music-page-top {
  padding-top: 125px;
  padding-bottom: 50px;
}

@media (max-width: 768px) {
  .music-page-top {
    padding-top: 220px;
  }
}

.tracks-container {
  max-width: 800px;
  margin: 0 auto;
}

.track-item {
  margin-bottom: 20px;
  background-color: #2a2c2d;
  border-radius: 4px;
  padding: 15px;
}

.track-embed {
  width: 100%;
}

.track-embed iframe {
  width: 100%;
  height: 166px;
  border: none;
}

.loading,
.error {
  text-align: center;
  padding: 40px;
}

.loading p,
.error p {
  font-size: 18px;
}
</style>
